// Same bank list used by the bank's substabelecimento form
export const bankOptions = `1 - Banco do Brasil S.A.
3 - Banco da Amazônia S.A.
4 - Banco do Nordeste do Brasil S.A.
7 - Banco Nacional de Desenvolvimento Econômico e Social – BNDES
10 - Credicoamo
11 - C.Suisse Hedging-Griffo Cv S.A (Credit Suisse)
12 - Banco Inbursa S.A.
14 - Natixis Brasil S.A. Banco Múltiplo
16 - Ccm Desp Trâns Sc E Rs
17 - BNY Mellon Banco S.A.
18 - Banco Tricury S.A.
21 - BANESTES S.A. Banco do Estado do Espírito Santo
24 - Banco BANDEPE S.A.
25 - Banco Alfa S.A.
29 - Banco Itaú Consignado S.A.
33 - Banco Santander (Brasil) S.A.
36 - Banco Bradesco BBI S.A.
37 - Banco do Estado do Pará S.A.
40 - Banco Cargill S.A.
41 - Banco do Estado do Rio Grande do Sul S.A.
47 - Banco do Estado de Sergipe S.A.
51 - Banco de Desenvolvimento do Espírito Santo S.A.
60 - Confidence Cc S.A
62 - Hipercard Banco Múltiplo S.A.
63 - Banco Bradescard S.A.
64 - Goldman Sachs do Brasil Banco Múltiplo S.A.
65 - Banco Andbank (Brasil) S.A.
66 - Banco Morgan Stanley S.A.
69 - Banco Crefisa S.A.
70 - BRB – Banco de Brasília S.A.
74 - Banco J. Safra S.A.
75 - Banco ABN AMRO S.A
76 - Banco KDB S.A.
77 - Banco Inter S.A.
78 - Haitong Banco de Investimento do Brasil S.A.
79 - Banco Original do Agronegócio S.A.
80 - B&T Cc Ltda
81 - BancoSeguro S.A.
82 - Banco Topázio S.A.
83 - Banco da China Brasil S.A.
84 - Uniprime Norte do Paraná – Coop de Economia eCrédito Mútuo dos Médicos, Profissionais das Ciências
85 - Coop Central Ailos
89 - Ccr Reg Mogiana
91 - Unicred Central Rs
92 - Brickell S.A. Crédito, Financiamento e Investimento
93 - Pólocred Scmepp Ltda
94 - Banco Finaxis S.A.
95 - Travelex Banco de Câmbio S.A.
96 - Banco B3 S.A.
97 - Cooperativa Central de Crédito Noroeste Brasileiro Ltda.
98 - Credialiança Ccr
99 - UNIPRIME Central – Central Interestadual de Cooperativas de Crédito Ltda.
100 - Planner Corretora De Valores S.A
101 - Renascenca Dtvm Ltda
102 - Xp Investimentos S.A
104 - Caixa Econômica Federal
105 - Lecca Crédito, Financiamento e Investimento S/A
107 - Banco BOCOM BBM S.A.
108 - Portocred S.A
111 - Banco Oliveira Trust Dtvm S.A
113 - Magliano S.A
114 - Central Cooperativa De Crédito No Estado Do Espírito Santo
117 - Advanced Cc Ltda
118 - Standard Chartered Bank (Brasil) S/A–Bco Invest.
119 - Banco Western Union do Brasil S.A.
120 - Banco Rodobens S.A.
121 - Banco Agibank S.A.
122 - Banco Bradesco BERJ S.A.
124 - Banco Woori Bank do Brasil S.A.
125 - Plural S.A. – Banco Múltiplo
126 - BR Partners Banco de Investimento S.A.
127 - Codepe Cvc S.A
128 - MS Bank S.A. Banco de Câmbio
129 - UBS Brasil Banco de Investimento S.A.
130 - Caruana Scfi
131 - Tullett Prebon Brasil Cvc Ltda
132 - ICBC do Brasil Banco Múltiplo S.A.
133 - Cresol Confederação
134 - Bgc Liquidez Dtvm Ltda
136 - Unicred Cooperativa
137 - Multimoney Cc Ltda
138 - Get Money Cc Ltda
139 - Intesa Sanpaolo Brasil S.A. – Banco Múltiplo
140 - Easynvest – Título Cv S.A
142 - Broker Brasil Cc Ltda
143 - Treviso Corretora de Câmbio S.A.
144 - BEXS Banco de Câmbio S.A.
145 - Levycam Ccv Ltda
146 - Guitta Corretora de Câmbio Ltda
149 - Facta S.A. Cfi
157 - Icap Do Brasil Ctvm Ltda
159 - Casa Credito S.A
163 - Commerzbank Brasil S.A. – Banco Múltiplo
169 - Banco Olé Bonsucesso Consignado S.A.
172 - Albatross Ccv S.A
173 - BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.
174 - Pernambucanas Financ S.A
177 - Guide Investimentos S.A. Corretora de Valores
180 - Cm Capital Markets Cctvm Ltda
182 - Dacasa Financeira S/A
183 - Socred S.A
184 - Banco Itaú BBA S.A.
188 - Ativa Investimentos S.A
189 - HS Financeira S/A Crédito, Financiamento e Investimentos
190 - Servicoop
191 - Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.
194 - Parmetal Distribuidora de Títulos e Valores Mobiliários Ltda
196 - Banco Fair Corretora de Câmbio S.A
197 - Stone Pagamentos S.A
204 - Banco Bradesco Cartões S.A.
208 - Banco BTG Pactual S.A.
212 - Banco Original S.A.
213 - Banco Arbi S.A.
217 - Banco John Deere S.A.
218 - Banco BS2 S.A.
222 - Banco Credit Agricole Brasil S.A.
224 - Banco Fibra S.A.
233 - Banco Cifra S.A.
237 - Banco Bradesco S.A.
241 - Banco Clássico S.A.
243 - Banco Máxima S.A.
246 - Banco ABC Brasil S.A.
249 - Banco Investcred Unibanco S.A.
250 - BCV – Banco de Crédito e Varejo S.A.
253 - Bexs Corretora de Câmbio S/A
254 - Paraná Banco S.A.
260 - Nu Pagamentos S.A (Nubank)
265 - Banco Fator S.A.
266 - Banco Cédula S.A.
268 - Barigui Companhia Hipotecária
269 - HSBC Brasil S.A. – Banco de Investimento
270 - Sagitur Corretora de Câmbio Ltda.
271 - IB Corretora de Câmbio, Títulos e Valores Mobiliários S.A.
273 - Cooperativa de Crédito Rural de São Miguel do Oeste – Sulcredi/São Miguel
276 - Senff S.A. – Crédito, Financiamento e Investimento
278 - Genial Investimentos Corretora de Valores Mobiliários S.A.
279 - Cooperativa de Crédito Rural de Primavera Do Leste
280 - Avista S.A. Crédito, Financiamento e Investimento
283 - Rb Capital Investimentos Dtvm Ltda
285 - Frente Corretora de Câmbio Ltda.
286 - Cooperativa de Crédito Rural De Ouro
288 - Carol Distribuidora de Títulos e Valor Mobiliários Ltda
290 - Pagseguro Internet S.A
292 - BS2 Distribuidora de Títulos e Valores Mobiliários S.A.
293 - Lastro RDV Distribuidora de Títulos e Valores Mobiliários Ltda.
298 - Vips Cc Ltda
299 - Sorocred Crédito, Financiamento e Investimento S.A.
300 - Banco de La Nacion Argentina
301 - Bpp Instituição De Pagamentos S.A
310 - Vortx Distribuidora de Títulos e Valores Mobiliários Ltda
318 - Banco BMG S.A.
320 - China Construction Bank (Brasil) Banco Múltiplo S.A.
323 - Mercado Pago – Conta Do Mercado Livre
326 - Parati – Crédito Financiamento e Investimento S.A.
335 - Banco Digio S.A
336 - Banco C6 S.A – C6 Bank
340 - Super Pagamentos e Administração de Meios Eletrônicos S.A.
341 - Itaú Unibanco S.A.
348 - Banco Xp S/A
366 - Banco Société Générale Brasil S.A.
368 - Banco Carrefour
370 - Banco Mizuho do Brasil S.A.
376 - Banco J. P. Morgan S.A.
389 - Banco Mercantil de Investimentos S.A.
389 - Banco Mercantil do Brasil S.A.
394 - Banco Bradesco Financiamentos S.A.
399 - Kirton Bank S.A. – Banco Múltiplo
403 - Cora SCD
412 - Banco Capital S.A.
422 - Banco Safra S.A.
456 - Banco MUFG Brasil S.A.
464 - Banco Sumitomo Mitsui Brasileiro S.A.
473 - Banco Caixa Geral – Brasil S.A.
477 - Citibank N.A.
479 - Banco ItauBank S.A
487 - Deutsche Bank S.A. – Banco Alemão
488 - JPMorgan Chase Bank, National Association
492 - ING Bank N.V.
494 - Banco de La Republica Oriental del Uruguay
495 - Banco de La Provincia de Buenos Aires
505 - Banco Credit Suisse (Brasil) S.A.
545 - Senso Ccvm S.A
600 - Banco Luso Brasileiro S.A.
604 - Banco Industrial do Brasil S.A.
610 - Banco VR S.A.
611 - Banco Paulista S.A.
612 - Banco Guanabara S.A.
613 - Omni Banco S.A.
623 - Banco PAN S.A.
626 - Banco Ficsa S.A.
630 - Banco Smartbank S.A.
633 - Banco Rendimento S.A.
634 - Banco Triângulo S.A.
637 - Banco Sofisa S.A.
641 - Banco Alvorada S.A.
643 - Banco Pine S.A.
652 - Itaú Unibanco Holding S.A.
653 - Banco Indusval S.A.
654 - Banco A.J.Renner S.A.
655 - Banco Votorantim S.A.
658 - Banco Porto Real de Investimentos S.A.
707 - Banco Daycoval S.A.
712 - Banco Ourinvest S.A.
720 - Banco Maxinvest S.A.
739 - Banco Cetelem S.A.
741 - Banco Ribeirão Preto S.A.
743 - Banco Semear S.A.
745 - Banco Citibank S.A.
746 - Banco Modal S.A.
747 - Banco Rabobank International Brasil S.A.
748 - Banco Cooperativo Sicredi S.A.
751 - Scotiabank Brasil S.A. Banco Múltiplo
752 - Banco BNP Paribas Brasil S.A.
753 - Novo Banco Continental S.A. – Banco Múltiplo
754 - Banco Sistema S.A.
755 - Bank of America Merrill Lynch Banco Múltiplo S.A.
756 - Banco Cooperativo do Brasil S.A. – BANCOOB
757 - Banco KEB HANA do Brasil S.A.
085-x - Cooperativa Central de Crédito Urbano-CECRED
087-6 - Cooperativa Central de Economia e Crédito Mútuo das Unicredsde Santa Catarina e Paraná
089-2 - Cooperativa de Crédito Rural da Região da Mogiana
090-2 - Cooperativa Central de Economia e Crédito Mutuo – SICOOB UNIMAIS
091-4 - Unicred Central do Rio Grande do Sul
098-1 - CREDIALIANÇA COOPERATIVA DE CRÉDITO RURAL
114-7 - Central das Cooperativas de Economia e Crédito Mútuo doEstado do Espírito Santo Ltda.
0 - Outro`.split("\n");
